module.exports = __webpack_public_path__ + "assets/img/00171.5a99abd3.png";